import React from 'react';
import { string } from 'prop-types';

import { Container, Wrapper } from './styles';

const RiskTag = ({ item }) => {
  return (
    <Container>
      <Wrapper status={item}>{item}</Wrapper>
    </Container>
  );
};

export default RiskTag;

RiskTag.propTypes = {
  item: string.isRequired,
};
